/**
 * Kullanıcı son hareketleri (#236) — saf yardımcılar.
 * Sözleşme: Workspace docs/api-contracts/user-activity.md
 */

/** Audit kategorisi → Türkçe etiket (Audit Log sayfasıyla aynı dil) */
export const ACTIVITY_CATEGORY_LABELS = {
  CREATE: "Oluşturma",
  UPDATE: "Güncelleme",
  DELETE: "Silme",
  READ: "Görüntüleme",
  LOGIN: "Giriş",
  LOGOUT: "Çıkış",
  PASSWORD_CHANGE: "Parola Değişimi",
  PERMISSION_CHANGE: "Yetki Değişimi",
  DEVICE_STATUS: "Cihaz Durumu",
  DEVICE_OPERATION: "Cihaz İşlemi",
  SYSTEM_TASK: "Sistem",
  VALIDATION: "Doğrulama",
  SIGNATURE: "İmza",
  AUTHZ: "Yetkilendirme",
  RATE_LIMIT: "İstek Sınırı",
  ERROR: "Hata",
  OTHER: "Diğer",
};

const dayKey = (date) =>
  `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;

const DAY_FORMAT = new Intl.DateTimeFormat("tr-TR", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

/** Gün başlığı: Bugün / Dün / "12 Ekim 2026" */
export function dayLabel(date, now = new Date()) {
  const today = dayKey(now);
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const key = dayKey(date);
  if (key === today) return "Bugün";
  if (key === dayKey(yesterday)) return "Dün";
  return DAY_FORMAT.format(date);
}

/**
 * Yeniden eskiye sıralı kayıtları gün gruplarına böler (sıra korunur).
 * @returns {Array<{ key: string, label: string, items: object[] }>}
 */
export function groupActivityByDay(items = [], now = new Date()) {
  const groups = [];
  items.forEach((item) => {
    const date = new Date(item.timestamp);
    const key = dayKey(date);
    const last = groups[groups.length - 1];
    if (last && last.key === key) {
      last.items.push(item);
    } else {
      groups.push({ key, label: dayLabel(date, now), items: [item] });
    }
  });
  return groups;
}

/**
 * Sayfaları biriktirir; aynı kayıt iki kez gelirse (ör. yeniden deneme)
 * tekrar eklenmez.
 */
export function appendActivityPage(prev = [], next = []) {
  const seen = new Set(prev.map((i) => String(i._id)));
  return [...prev, ...next.filter((i) => !seen.has(String(i._id)))];
}

/**
 * Son İşlemler (#308): panel yeniden açılınca gelen İLK sayfayı mevcut listeyle
 * birleştirir — daha önce görülmeyen kayıtlar ÜSTE eklenir, eski sayfaların
 * imleci korunur. İlk sayfanın hiçbiri listede yoksa (panel kapalıyken bir
 * sayfadan fazla işlem yapılmış) arada boşluk kalmasın diye liste baştan kurulur.
 *
 * @param {{ items: object[], cursor: string|null, hasMore: boolean }} prev
 * @param {{ items?: object[], nextCursor?: string|null, hasMore?: boolean }} page
 * @returns {{ items: object[], cursor: string|null, hasMore: boolean, addedIds: string[], reset: boolean }}
 */
export function mergeLatestPage(prev, page) {
  const latest = page?.items || [];
  const fromPage = (addedIds) => ({
    items: latest,
    cursor: page?.nextCursor || null,
    hasMore: !!page?.hasMore,
    addedIds,
    reset: true,
  });
  if (!prev?.items?.length) return fromPage([]);
  const known = new Set(prev.items.map((i) => String(i._id)));
  if (!latest.some((i) => known.has(String(i._id)))) return fromPage([]);
  const fresh = latest.filter((i) => !known.has(String(i._id)));
  return {
    items: [...fresh, ...prev.items],
    cursor: prev.cursor,
    hasMore: prev.hasMore,
    addedIds: fresh.map((i) => String(i._id)),
    reset: false,
  };
}
